// =============================================================================
// PlayerPortal — shared shell for every authenticated player page
// =============================================================================
// The portal is one product surface, not a collection of unrelated pages.
// Identity comes from GET /api/me/profile, which resolves the player from the
// JWT. The browser never supplies a recruit id.

import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../lib/api.js';
import PlayerMasthead from './PlayerMasthead.jsx';
import MyProfile from '../pages/MyProfile.jsx';
import MyOutreach from '../pages/MyOutreach.jsx';
import MyPlans from '../pages/MyPlans.jsx';

function tabClass(isActive) {
  return `border-b-4 px-1 py-3 text-sm font-bold transition-colors ${
    isActive
      ? 'border-mid-green text-hunter'
      : 'border-transparent text-silver-mute hover:text-hunter'
  }`;
}

export default function PlayerPortal() {
  const [playerName, setPlayerName] = useState('');
  const [searchParams] = useSearchParams();
  const requestedTab = searchParams.get('tab');
  const activeTab = requestedTab === 'email-campaigns' || requestedTab === 'plans' ? requestedTab : 'profile';

  useEffect(() => {
    let alive = true;
    api.get('/api/me/profile')
      .then(({ recruit }) => {
        if (!alive || !recruit) return;
        setPlayerName([recruit.first_name, recruit.last_name].filter(Boolean).join(' '));
      })
      .catch(() => { /* The page below owns the actionable error state. */ });
    return () => { alive = false; };
  }, []);

  return (
    <div className="min-h-screen bg-fo-canvas">
      <PlayerMasthead playerName={playerName} />
      <nav className="border-b border-gray-200 bg-white" aria-label="Player portal">
        <div className="max-w-5xl mx-auto px-4 flex gap-7">
          <Link to="/my-profile" className={tabClass(activeTab === 'profile')}>Player Profile</Link>
          <Link to="/my-profile?tab=email-campaigns" className={tabClass(activeTab === 'email-campaigns')}>Email Campaigns</Link>
          <Link to="/my-profile?tab=plans" className={tabClass(activeTab === 'plans')}>Plans</Link>
        </div>
      </nav>
      {activeTab === 'profile' && <MyProfile />}
      {activeTab === 'email-campaigns' && <MyOutreach />}
      {activeTab === 'plans' && <MyPlans playerName={playerName} />}
    </div>
  );
}
